import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProductComponent } from './product/product.component';
import { InstallComponent } from './install/install.component';
import { GalleryComponent } from './gallery/gallery.component';
import { MoreProductComponent } from './more-product/more-product.component';


const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'install', component: InstallComponent},
    {path: 'gallery', component: GalleryComponent},
    {path: 'moreproduct', component: MoreProductComponent }
];


@NgModule({
    imports: [ RouterModule.forRoot(routes, {useHash: true}) ],
    exports: [ RouterModule ]
  })
  // tslint:disable-next-line:eofline
  export class AppRoutingModule {}


// WEBPACK FOOTER //
// /Users/samirjha/Project/nushing/src/app/app-routing.ts